
import createValidatePropsMethod from './../lib/createValidatePropsMethod'

/**
 * Checks that the repository is a valid object and doesn't have invalid props.
 * Will throw if it does
 * @param {object} repository
 */
const validateRepository = createValidatePropsMethod({
  'id': `Missing prop on repository 'id'.`,
  'ownerId': `Missing prop on repository 'ownerId'.`,
  'name': `Missing prop on repository 'name'.`,
  'updatedAt': `Missing prop on repository 'updatedAt'.`,
})


/**
 * Add a repository
 * @param {object} repository Expects object props of name, id, ownerId
 */
export function addRepository(repository){
  validateRepository(repository)
  return {
    type: 'ADD_REPOSITORY',
    payload: {
      repository,
    },
  }
}

/**
 * Load a repository schema
 * @param {number} id Repository id
 */
export function loadBranches(repoId){
  if (!repoId)
    throw new Error(`Invalid 'repoId' ${repoId}`)
  return {
    type: 'LOAD_BRANCHES',
    payload: {
      repoId,
    }
  }
}

/**
 * Set the currently selected branch
 * @param {string} branchId
 * @param {string} repositoryId
 * @returns {object}
 */
export function setSelectedBranch(branchId, repositoryId){
  return {
    type: 'SET_SELECTED_BRANCH',
    payload: {
      branchId, repositoryId
    },
  }
}

/**
 * Create's a repository
 * @param {string} newRepositoryName
 * @param {string} ownerId
 * @returns {object}
 */
export function createRepository(newRepositoryName, ownerId){
  return {
    type: 'CREATE_REPOSITORY',
    payload: {
      newRepositoryName,
      ownerId,
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/repositories/actions.js